import { render } from "./HotListControls.vue?vue&type=template&id=8d046f7a&scoped=true"
import script from "./HotListControls.vue?vue&type=script&lang=js"
export * from "./HotListControls.vue?vue&type=script&lang=js"

import "./HotListControls.vue?vue&type=style&index=0&id=8d046f7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d046f7a"]])

export default __exports__